<template>
  <a-row :gutter="24">
    <a-col :span="12">
      <a-form-model-item
        label="发布方式"
        prop="disclosureMethod"
        extra="正式发布日期从审核完成后次工作日起算"
      >
        <a-radio-group v-model="form.disclosureMethod" disabled>
          <a-radio :value="1">审核完成即刻发布</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item
        label="公告发布期(工作日)"
        prop="disclosurePeriod"
        extra="一般不少于5个工作日"
      >
        <a-input-number
          :min="5"
          :precision="0"
          style="width: 100%"
          v-model="form.disclosurePeriod"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <div style="width: 70%; margin: auto">
        <a-form-model-item
          label="招租公告发布期满"
          prop="disclosurePeriodExtend"
        >
          <a-radio-group v-model="form.disclosurePeriodExtend">
            <a-radio :value="14">变更招租公告内容，重新申请发布招租</a-radio>
            <br />
            <a-radio :value="12">
              <span class="radio-inline-wrap">
                <span>延长发布，不变更招租公告条件，按照</span>
                <a-form-model-item
                  prop="extendWorkingDays"
                  class="inline-form-item"
                  :colon="false"
                >
                  <a-input-number
                    :min="1"
                    :precision="0"
                    v-model="form.extendWorkingDays"
                    class="inline-input"
                    :disabled="form.disclosurePeriodExtend !== 12"
                  />
                </a-form-model-item>
                <span>工作日为一个延长周期，延长</span>

                <a-form-model-item
                  prop="extendedCyclesNumber"
                  class="inline-form-item"
                  :colon="false"
                >
                  <a-input-number
                    :min="1"
                    :precision="0"
                    v-model="form.extendedCyclesNumber"
                    class="inline-input"
                    :disabled="form.disclosurePeriodExtend !== 12"
                  />
                </a-form-model-item>
                <span>周期</span>
              </span>
            </a-radio>
            <br />
            <a-radio :value="11">招租公告发布终结</a-radio>
            <br />
          </a-radio-group>
        </a-form-model-item>
      </div>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style scoped>
/* radio 整体改成 flex，居中对齐 */
.ant-radio-wrapper {
  display: inline-flex !important;
  align-items: center;
}

/* 包住整句话 */
.radio-inline-wrap {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

/* form-item 行内显示 */
.inline-form-item {
  display: inline-flex !important;
  align-items: center;
  margin: 0 8px !important;
}

/* 去掉 form-item 默认下边距 */
.inline-form-item .ant-form-item {
  margin-bottom: 0 !important;
}

/* 输入框统一规格 */
.inline-input {
  width: 140px;
  min-width: 100px;
  max-width: 150px;
  margin-top: 10px;
}
</style>